import script from "./TressNavigationPills.vue?vue&type=script&setup=true&lang=ts"
export * from "./TressNavigationPills.vue?vue&type=script&setup=true&lang=ts"

import "./TressNavigationPills.vue?vue&type=style&index=0&id=5d7bf320&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5d7bf320"]])

export default __exports__